"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgProvidedInputTypeIterable = void 0;
/**
 * Org Provided Inputs Domain provides a key:value store-like framework for primitive values, but tailored to Finley's needs.
 * Specially, keys must be associated with an organizationId. Values (associated with respective keys) are also persisted with a reportingDate+version
 * such that they can speak the common language of "reportingPeriod", making them queryable by other domains with reportingPeriod needs.
 *
 * Keys (and their associated configuration) are stored in org_provided_inputs table.
 * Values (and their associated metadata) are stored in org_provided_values table.
 *
 * Once a key (and configuration) is created, it is immutable.  key+orgId is unique.
 * Once a value is created, it is immutable.  If multiple values of the same key are required for the same reportingDate, the version
 * will be auto-incremented (version is not exposed an input when creating a key,
 * it will be determined by the domain/data accessor during insert)
 */
// null is covered via nullable flag
exports.OrgProvidedInputTypeIterable = [
    'string',
    'number',
    'boolean',
    'fullDateStr',
];
//# sourceMappingURL=OrgProvidedInputs.js.map